import { Route, Routes } from "react-router-dom";
import LandingPage from './Pages/LandingPage';
import ProjectsLandingPage from './Pages/ProjectsLandingPage'
import Projects from './Discontinued/Projects'
import Contact from './Discontinued/Contact'
import HotWheels from "./Pages/HotWheels";
import Widgets from "./Pages/Widgets";
import GuitarTabs from "./Pages/GuitarTabs";
import GradeCalculator from "./Pages/GradeCalculator";

export default function MainPage(){
    return (
        <div>
            <Routes>
                <Route path='/' element={<LandingPage></LandingPage>}>
                </Route>
                <Route path='projects/*' element={<ProjectsLandingPage/>}>
                </Route>
                <Route path='contact' element={<Contact/>}>
                </Route>
                <Route path='hotwheels' element={<HotWheels/>}>
                </Route>
                <Route path='widgets' element={<Widgets/>}>
                </Route>
                <Route path='tabs' element={<GuitarTabs/>}>
                </Route>
                <Route path='grade_calculator' element={<GradeCalculator/>}>
                </Route>
            </Routes>
        </div>
    )
}